import { TooltipHost } from "@fluentui/react";
const CRMButton = ({ ids, isValid, content, tooltipProps, onClick }) => {
  return (
    <TooltipHost content={isValid ? tooltipProps[0] : tooltipProps[1]}>
      <div className="crm-btn" id={isValid ? ids[0] : ids[1]} onClick={onClick}>
        {isValid ? content[0] : content[1]}
      </div>
    </TooltipHost>
  );
};

export default CRMButton;
